import { useEffect } from "react";
import type { RouteDef } from "../routes";

/**
 * Placeholder for routes whose content lands in a later phase. It is explicit
 * about being unbuilt rather than showing thin filler copy that could be
 * mistaken for a finished page.
 */
export function StubPage({ route }: { route: RouteDef }) {
  useEffect(() => {
    document.title = `${route.title} — Odingard`;
  }, [route.title]);

  return (
    <main className="page" id="main">
      <section className="page__hero">
        {route.eyebrow && <p className="page__eyebrow">{route.eyebrow}</p>}
        <h1>{route.title}</h1>
        {route.lede && <p className="page__lede">{route.lede}</p>}
      </section>
      <p className="page__stub">
        This page is part of the corporate information architecture and is
        scheduled for a later build phase. The route exists so navigation
        resolves and the structure can be reviewed end to end.
      </p>
    </main>
  );
}
